<div class="backdrop" (click)="close()"></div>
<div class="chatWrapper">
  <div class="chatInner">
    <div class="rfqHeader">
      <div class="flex align-items-center">
        <h3 matTooltip="{{ rfqItem?.projectName }}" class="medium font-14">
          {{ rfqItem?.projectName }}
        </h3>
        <span class="info_bar">{{
          getRFQTemplateLabel(rfqItem?.rfqTemplate)
          }}</span>
        <span class="rfqOthersText" *ngIf="
            rfqItem?.othersText && rfqItem?.rfqTemplate == templateType.Others
          ">({{ rfqItem.othersText }})</span>
      </div>
      <span class="rfqStatus font-12 medium status" *ngIf="rfqItem?.status" [class]="rfqItem?.status">{{
        getStatusLabel(rfqItem.status)
        }}</span>
      <div class="rfqActions">
        <span class="rfqClose" (click)="close()">
          <lucide-icon name="X" class="close_icon"></lucide-icon>
        </span>
      </div>
    </div>
    <div class="rfqBody">
      <div class="basicDetail">
        <div class="accordianWrapper row">
          <div class="accordion-header">
            <div class="rfqInfo col-lg-5 col-md-5">
              <span class="subLabel d-block font-12 medium">RFQ ID : {{ rfqItem?.id }}</span>
              <span class="subLabel d-block font-12 medium">Created On: {{ rfqItem?.createdOn | date : "MMM d, y"
                }}</span>
              <span class="subLabel d-block font-12 medium">Delivery Date:
                {{ rfqItem?.deliveryDate | date : "MMM d, y" }}</span>
              <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.incoTerm">Incoterms : {{ rfqItem?.incoTerm
                }}</span>
              <span *ngIf="
                  rfqItem?.paymentTerm && rfqItem?.paymentTerm == 'Custom Terms'
                " matTooltip="{{ rfqItem?.paymentTermRemarks }}" class="subLabel d-block font-12 medium">Payment Term:
                {{ rfqItem?.paymentTerm }} -
                {{ rfqItem?.paymentTermRemarks }}</span>
              <span *ngIf="rfqItem?.paymentTerm != 'Custom Terms'" class="subLabel d-block font-12 medium">Payment Term:
                {{ rfqItem?.paymentTerm }}
              </span>
              <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.moq">Quantity: {{
                rfqItem?.moq }}</span>
              <span class="subLabel d-block font-12 medium">Delivery Address: {{ rfqItem?.address }}</span>
              <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.poNo">P.O. Number: {{ rfqItem?.poNo }}</span>
              <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.poDate">P.O. Date: {{ rfqItem?.poDate | date : "MMM d, y" }}</span>
              <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.customerPDCAmount">Post Dated Cheque(PDC) Amount: {{ rfqItem?.customerPDCAmount.toLocaleString('en-IN') }} {{ rfqItem?.customerPDCCurrency }}</span>
              <span class="subLabel d-block font-12 medium" *ngIf="rfqItem?.customerPDCDueDate">Post Dated Cheque(PDC) Due Date: {{ rfqItem?.customerPDCDueDate | date : "MMM d, y" }}</span>
              <span class="subLabel d-block font-12 medium">Secondary Processes
                <ng-container
                  *ngFor="let matItem of (rfqItem?.secondaryProcesses | categoryFormatter: 2 : rfqItem?.materialOthers).display">
                  <span class="badge_chip"
                    [matTooltip]="(rfqItem?.secondaryProcesses | categoryFormatter: 2 : rfqItem?.materialOthers).tooltip">
                    {{ matItem }}
                  </span>
                </ng-container></span>
            </div>
            <div class="rfqInfo col-lg-4 col-md-4">
              <h4>Category</h4>
              <div class="category-chips-and-more">
                <mat-chip *ngFor="
                    let cat of (
                      (rfqItem?.createdByShop
                        ? rfqItem?.mroCategory
                        : rfqItem?.category
                      ) | categoryFormatter : 2
                    ).display
                  ">
                  <span class="capability" [matTooltip]="
                      (
                        (rfqItem?.createdByShop
                          ? rfqItem?.mroCategory
                          : rfqItem?.category
                        ) | categoryFormatter : 2
                      ).tooltip
                    ">
                    {{ cat }}
                  </span>
                </mat-chip>

                <span (click)="isMoreExpanded = true" *ngIf="!isMoreExpanded" class="more-less-button">
                  <mat-icon>expand_more</mat-icon></span>
              </div>
            </div>
          </div>
          <div *ngIf="isMoreExpanded" class="mt-10 expandCategory">
            <h4>Sub-Category</h4>
            <div class="category-chips-and-more">
              <mat-chip *ngFor="
                  let cat of (
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroSubCategory
                      : rfqItem?.subCategory
                    ) | categoryFormatter : 2 : rfqItem?.categoryOthers
                  ).display
                ">
                <span class="capability" [matTooltip]="
                    (rfqItem?.createdByShop
                      ? rfqItem?.mroSubCategory
                      : (rfqItem?.subCategory
                        | categoryFormatter : 2 : rfqItem?.categoryOthers)
                    ).tooltip
                  ">
                  {{ cat }}
                </span>
              </mat-chip>
            </div>
            <h4 *ngIf="rfqItem?.materials.length != 0">Materials</h4>
            <div class="category-chips-and-more">
              <div>
                <mat-chip *ngFor="
                    let material of (
                      rfqItem?.materials
                      | categoryFormatter : 2 : rfqItem?.materialOthers
                    ).display
                  ">
                  <span class="capability" [matTooltip]="
                      (
                        rfqItem?.materials
                        | categoryFormatter : 2 : rfqItem?.materialOthers
                      ).tooltip
                    ">
                    {{ material }}
                  </span>
                </mat-chip>
              </div>
              <span (click)="isMoreExpanded = false" class="more-less-button">
                <mat-icon>expand_less</mat-icon></span>
            </div>
          </div>
        </div>
      </div>
      <div class="newAttachment" *ngIf="
          rfqItem?.status !== RFQStatus.PO_ACCEPTED && 
          rfqItem?.status !== RFQStatus.QUOTE_ACCEPTED &&
          rfqItem?.status !== RFQStatus.QUOTE_READY &&
          rfqItem?.status !== RFQStatus.PO_RAISED &&
          !rfqItem?.createdByShop
        ">
        <h4 class="flex font-14 medium">
          New Attachments:
          <span class="attach" *ngIf="attachments.length > 0">
            {{ attachments.length || 0 }}
            file(s)
          </span>
          <span (click)="toggleAttachment()" class="ml-auto"
            *ngIf="!(rfqItem?.status === RFQStatus.QUOTE_ACCEPTED || rfqItem?.status === RFQStatus.QUOTE_READY || rfqItem?.status === RFQStatus.PO_ACCEPTED)">
            <lucide-icon [name]="isExpanded ? 'minus' : 'plus'" class="my-icon fileIco" [size]="20"></lucide-icon>
          </span>
        </h4>
        <div class="attachWrapp" *ngIf="isExpanded">
          <ng-container *ngTemplateOutlet="newAttchment"></ng-container>
        </div>
      </div>
      <div class="newAttachment" *ngIf="rfqItem?.status === RFQStatus.QUOTE_ACCEPTED && !Sendarchive">
        <h2 class="flex font-14 medium">Upload P.O. <sup>*</sup></h2>
        <ng-container *ngTemplateOutlet="poAttchment"></ng-container>
      </div>

      <div class="newAttachment" *ngIf="
          (rfqItem?.status == RFQStatus.PO_ACCEPTED || 
          rfqItem?.status == RFQStatus.PO_RAISED ||
          rfqItem?.status == RFQStatus.QUOTE_ACCEPTED ) && 
          pdcFiles.length == 0">
        <h2 class="flex font-14 medium">Upload Post Dated Cheque (P.D.C.)</h2>
        <ng-container *ngTemplateOutlet="pdcAttachment"></ng-container>
      </div>
      
      <div class="quoteRaise" *ngIf="rfqItem?.status === RFQStatus.QUOTE_READY && !Sendarchive">
        <ng-container *ngTemplateOutlet="quoteReady"></ng-container>
      </div>
      <div class="quoteRaise" *ngIf="rfqItem?.status === RFQStatus.PO_ACCEPTED && !Sendarchive">
        <ng-container *ngTemplateOutlet="poAccepted"></ng-container>
      </div>
      <!-- <div class="fileInfo" *ngIf="!rfqItem?.createdByShop"> -->
      <div class="fileInfo" >
        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: getFileTypes() }"></ng-container>
      </div>

      <div class="quoteRaise" *ngIf="rfqItem?.status === RFQStatus.NOT_FEASIBLE && !Sendarchive">
        <ng-container *ngTemplateOutlet="notFeasible"></ng-container>
      </div>

      <div *ngIf="rfqItem?.createdByShop">
        <lib-line-items [custRfqId]="rfqInfo.id" [baseUrl]="baseUrl"></lib-line-items>
      </div>
    </div>
    <div class="rfqFooter">
      <div *ngIf="!(rfqItem?.status === RFQStatus.QUOTE_ACCEPTED || rfqItem?.status === RFQStatus.QUOTE_READY || rfqItem?.status === RFQStatus.PO_ACCEPTED)">
        <!-- <button id="modules_rfq_rfqquote_4" mat-button class="drafts-button" (click)="close()">
          Cancel
        </button> -->
        <button id="modules_rfq_rfqquote_5" mat-button color="primary" type="button" class="btnCustom btn-primary" 
          *ngIf="
            rfqItem?.status == RFQStatus.QUOTE_IN_PROGRESS &&
            !Sendarchive &&
            !rfqItem?.createdByShop
          " [ngClass]="{ disable: saveButtonEnable }" (click)="updateRFQFile()">
          Save
        </button>
      </div>
      <button id="modules_rfq_rfqquote_18" mat-button color="primary" type="button" class="btnCustom btn-primary"
        (click)="updatePDCFile()" 
          *ngIf="(
            rfqItem?.status == RFQStatus.PO_ACCEPTED || 
            rfqItem?.status == RFQStatus.PO_RAISED ) && 
            pdcFiles.length == 0" 
          [disabled]="!isPdcDetailsUploaded"
          >
        Upload P.D.C. 
      </button>
      <button id="modules_rfq_rfqquote_14" mat-button color="primary" type="button" class="btnCustom btn-primary"
        *ngIf="rfqItem?.status == RFQStatus.QUOTE_READY && !Sendarchive" (click)="acceptQuote()">
        Accept Quote
      </button>
      <button id="modules_rfq_rfqquote_18" mat-button color="primary" type="button" class="btnCustom btn-primary"
        (click)="updatePOFile()" *ngIf="rfqItem?.status === RFQStatus.QUOTE_ACCEPTED && !Sendarchive"
        [disabled]="!isPoUploaded || !isPoDetailsValid">
        Upload P.O.
      </button>
    </div>
  </div>
</div>
<ng-template #quoteReady>
  <div class="swiftQuote" *ngIf="rfqItem.status === RFQStatus.QUOTE_READY">
    <div class="swiftIco">
      <img src="../../../../assets/images/icon/quote.svg" alt="" />
    </div>
    <div class="swiftContent">
      <h3 class="medium font-16">Your Swift Quote is Ready!</h3>
      <p>
        Our quote engine brings you the best price. Download, review and confirm
        to accept.
      </p>
      <button id="modules_rfq_rfqquote_7" mat-button color="primary" type="button" class="btnCustom btn-outline-primary"
        (click)="downloadAllQuoteFiles(rfqItem.attachments)">
        Download Quote
      </button>
    </div>
  </div>
</ng-template>
<ng-template #poAccepted>
  <div class="po-sent">
    <div class="po-accepted flex justify-content-between complete" [ngClass]="{ complete: true }">
      <div class="po-sent-first-upper">
        <span><span class="check-icon">&#10003;</span> P.O. Sent</span>
      </div>
    </div>
    <div class="po-sent-inner">
      <div *ngFor="let poAttachment of rfqItem.attachments; let i = index" class="po-file">
        <!-- Live PO Files -->
        <div *ngIf="
            poAttachment?.fileType === FileType.PO &&
            poAttachment?.fileStatus === fileStatus.Live
          ">
          <label class="font-12 medium pl-1">Latest P.O.</label>
          <div class="listWrap">
            <div class="single-file flex justify-content-between">
              <div class="flex file">
                <div class="rfq-item rfq-icon">
                  <lucide-icon name="FileText" class="icon"></lucide-icon>
                  <h6>{{ poAttachment.fileName }}</h6>
                </div>
                <div class="info">
                  <span class="name">
                    {{ poAttachment.fileSize }}
                    {{ poAttachment.createdOn | date : "dd MMMM yyyy hh:mm a" }}
                  </span>
                </div>
              </div>
              <span class="user">{{ UserType.Customer }}</span>
              <span class="rfqItem rfqDownloadIco" (click)="downloadFile(poAttachment.id, poAttachment.fileName)">
                <lucide-icon name="Download" class="icon"></lucide-icon>
              </span>
            </div>
          </div>
        </div>

        <!-- Archive PO Files -->
        <div *ngIf="
            poAttachment?.fileType === FileType.PO &&
            poAttachment?.fileStatus === fileStatus.Archive
          ">
          <label class="font-12 medium pl-1">Previous P.O.</label>
          <div class="listWrap">
            <div class="single-file flex justify-content-between">
              <div class="flex file">
                <div class="rfq-item rfq-icon">
                  <lucide-icon name="FileText" class="icon"></lucide-icon>
                  <h6>{{ poAttachment.fileName }}</h6>
                </div>
                <div class="info">
                  <span class="name">
                    {{ poAttachment.fileSize }}
                    {{ poAttachment.createdOn | date : "dd MMMM yyyy hh:mm a" }}
                  </span>
                </div>
              </div>
              <span class="user">{{ UserType.Customer }}</span>
              <span class="rfqItem rfqDownloadIco" (click)="downloadFile(poAttachment.id, poAttachment.fileName)">
                <lucide-icon name="Download" class="icon"></lucide-icon>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="po-pending" [ngClass]="{ complete: true }">
      <span><span class="check-icon">&#10003;</span>P.O. Accepted</span>
    </div>
  </div>
</ng-template>
<ng-template #newAttchment>
  <div class="invoiceUpload">
    <div class="uploader">
      <app-upload-dnd (fileUploadEvent)="fileUploadEvent($event, 'additional')" [documentInfo]="documentInfo"
        [fileUploadConfig]="fileUploadConfig" [resetFileUpload]="resetFileUpload" [showDragDrop]="true">
      </app-upload-dnd>
    </div>
  </div>
</ng-template>

<ng-template #poAttchment>
  <div class="invoiceUpload">
    <div [formGroup]="pdcDetailsForm">
      <div class="row wrappInside">
        <div class="col-sm-6">
          <div class="formGroup">
            <label>P.O. Number <sup>*</sup></label>
            <mat-form-field appearance="outline" [ngClass]="rfqItem?.poNo ? 'disabled' : ''">
              <input
                id="modules_rfq_createrfq_1"
                maxlength="200"
                matInput
                formControlName="poNumber"
                placeholder="P.O. Number"
                [disabled]="rfqItem?.poNo"
                [readonly]="rfqItem?.poNo"
              />
            </mat-form-field>
            <div class="errorTxt">
              <div
                *ngIf="
                  pdcDetailsForm?.get('poNumber')?.touched ||
                  pdcDetailsForm?.get('poNumber')?.dirty || (isPoUploaded && !pdcDetailsForm?.get('poNumber')?.value)">
                <div
                  *ngIf="pdcDetailsForm?.get('poNumber')?.hasError('required')">
                  P.O. Number is required
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="formGroup">
            <label>P.O. Date <sup>*</sup></label>
            <mat-form-field appearance="outline">
              <input
                matInput
                placeholder="P.O. Date"
                [matDatepicker]="poDatePicker"
                formControlName="poDate"          
                [matDatepickerFilter]="disableFutureDates"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="poDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #poDatePicker></mat-datepicker>
            </mat-form-field>
            <div class="errorTxt">
              <div
                *ngIf="
                  pdcDetailsForm?.get('poDate')?.touched ||
                  pdcDetailsForm?.get('poDate')?.dirty || (isPoUploaded && !pdcDetailsForm?.get('poDate')?.value)">
                <div
                  *ngIf="pdcDetailsForm?.get('poDate')?.hasError('required')">
                  P.O. Date is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uploader">
        <app-upload-dnd (fileUploadEvent)="fileUploadEvent($event, 'po')" [documentInfo]="documentInfo"
          [fileUploadConfig]="fileUploadConfig" [resetFileUpload]="resetFileUpload" [showDragDrop]="true">
        </app-upload-dnd>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #pdcAttachment>
  <div class="invoiceUpload">
    <div [formGroup]="pdcDetailsForm">
      <div class="row wrappInside">
        <div class="col-sm-4">
          <div class="formGroup">
            <label>PDC Amount</label>
            <mat-form-field appearance="outline">
              <input
                id="modules_rfq_createrfq_1"
                type="number"
                (wheel)="$event.preventDefault()"
                maxlength="200"
                matInput
                formControlName="pdcAmount"
                placeholder="PDC Amount"
              />
            </mat-form-field>
            <div class="errorTxt">
              <div
                *ngIf="
                  pdcDetailsForm?.get('pdcAmount')?.touched ||
                  pdcDetailsForm?.get('pdcAmount')?.dirty">
                <div
                  *ngIf="pdcDetailsForm?.get('pdcAmount')?.hasError('required')">
                  PDC Amount is required
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="formGroup">
            <label>PDC Currency</label>
            <mat-form-field appearance="outline">
              <mat-select
                class="select"
                formControlName="customerPDCCurrency"
                placeholder="Select Currency">
                <mat-option
                  *ngFor="let curr of currencyData"
                  [value]="curr.currencyType"
                  [disabled]="curr.currencyType !== 'INR'"
                >
                  {{ curr.currencyType }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="col-md-6">
          <div class="formGroup">
            <label>PDC Due Date</label>
            <mat-form-field appearance="outline">
              <input
                matInput
                placeholder="Due Date"
                [matDatepicker]="picker"
                formControlName="dueDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="uploader">
        <app-upload-dnd (fileUploadEvent)="fileUploadEvent($event, 'pdc')" [documentInfo]="pdcDocumentInfo"
          [fileUploadConfig]="pdcFileUploadConfig" [resetFileUpload]="resetFileUpload" [showDragDrop]="true">
        </app-upload-dnd>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #fileList let-fileData>
  <div class="listWrap">
    <h3 class="font-16 medium">
      Last Uploaded: {{ rfqItem?.attachments?.length || 0 }} Files
    </h3>
    <div class="fileItem" *ngFor="let files of fileData; let i = index">
      <h5 class="medium">{{ getFileTypeLabel(files.key) }}</h5>
      <div *ngIf="files.value">
        <div *ngFor="let item of files.value">
          <div class="single-file flex justify-content-between">
            <div class="flex file">
              <div class="rfq-item rfq-icon">
                <lucide-icon name="FileText" class="icon"></lucide-icon>
                <h6>{{ item.fileName }}</h6>
              </div>
              <div class="info">
                <span class="name">
                  {{ item.fileSize }}
                  {{ item.createdOn | date : "dd MMMM yyyy hh:mm a" }}
                </span>
              </div>
            </div>
            <span class="user">{{ getFileTypeLabel(files.key) }}</span>
            <span class="rfqItem rfqDownloadIco" (click)="downloadFile(item.id, item.fileName)">
              <lucide-icon name="Download" class="icon"></lucide-icon>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #notFeasible>
  <div class="form_content discontinue_box mt-20">
    <div class="heading">
      <h3 class="flex align-items-center">
        <lucide-icon name="triangle-alert" [size]="16" class="icon"></lucide-icon>
        RFQ Not Feasible
      </h3>
    </div>
    <div class="returnedBox">
      <div class="formGroup">
        <h4 class="reasonHead">
          Reason: {{ rfqItem?.feasibilityRemarkList[0]?.returnReason }}
        </h4>

        <p class="remarks">
          Remarks: {{ rfqItem?.feasibilityRemarkList[0]?.remark }}
        </p>
      </div>

      <div *ngIf="rfqItem?.adminAttachments">
        <div class="tableList" *ngFor="let attachment of rfqItem?.adminAttachments">
          <div *ngIf="attachment.fileType == 'Discontinued'">
            <span class="rfqItem rfqDownloadIco flex align-items-center"
              (click)="downloadFile(attachment.id, attachment.fileName)">
              <lucide-icon name="paperclip" class="icon"></lucide-icon> Download
              Attachment
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
